import { z } from "zod"

export const softReceivedGoodsReceiptFormSchema = z.object({
  trackingNumbers: z.array(z.string().max(50, "Container/Tracking# must not exceed 50 characters")).optional(),
  destination: z.string(),
  palletQtyDelivered: z
    .number({ required_error: "Pallet Qty Delivered is required" })
    .positive({ message: "Pallet Qty Delivered must be a positive number" })
    .refine((val) => val === null || Number.isInteger(val * 100), {
      message: "Pallet Qty Delivered must have at most 2 decimal places",
    })
    .nullable()
    .refine((val): boolean => val !== null, { message: "Pallet Qty Delivered is required" }),
  spacesUsed: z.number().int().positive({ message: "Spaces Used must be a positive integer" }).nullable(),
})

export type SoftReceivedGoodsReceiptFormValues = z.infer<typeof softReceivedGoodsReceiptFormSchema>
